/**
 * The staff fleet on the new balance and the Rate Card's "DANI conversion changes" (M4S-5895,
 * plan step 29; docs/pdlc/credits-ui.md §7 "Fleet").
 *
 * Both wait on this staff flag, read in the browser (it is about the staff member's page, never a
 * client's credits, so it is not `credits-ledger-balance`). It fails to off: unread, unknown or
 * off, `/tools/credits` and the Rate Card are today's and none of the fleet's reads runs. Turn it
 * on per staff member to rehearse on test1, and for CS once orgs start to flip.
 *
 * Kept out of the hooks so `FEATURE_FLAG_KEYS` can import it: the browser fetches only registered
 * keys, and an unregistered one reads off whatever its overrides say.
 */
export const FLEET_BALANCE_FLAG = 'credits-fleet-balance';
